import { Injectable, NgZone } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackbarSuccessComponent } from "../shared/components/snackbar-success/snackbar-success.component";
import { SnackbarErrorComponent } from "../shared/components/snackbar-error/snackbar-error.component";

@Injectable({
  providedIn: "root"
})
export class NotificationService {
  constructor(
    private readonly snackBar: MatSnackBar,
    private readonly zone: NgZone
  ) { }

  success(message: string, duration: number = 3000) {

    this.snackBar.openFromComponent(SnackbarSuccessComponent, {
      duration: duration,
      data: message,
      panelClass: 'success-notification-overlay',
    });

  }
  openErrorSnackbarComponent(error: any, duration: number = 5000) {
      this.snackBar.openFromComponent(SnackbarErrorComponent, {
        duration: duration,
        data: error,
        panelClass: 'error-notification-overlay',
      })
  }
  // error(message: string, duration: number = 3000) {
  //   this.zone.run(() =>
  //     this.snackBar.openFromComponent(SnackbarError2Component, {
  //       duration: duration,
  //       data: message,
  //       panelClass: 'error-notification-overlay',
  //     })
  //   );
  // }

}
